module.exports = __webpack_public_path__ + "assets/img/page_4.5c96a38c.png";